"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SnortSystemDb = void 0;
const dexie_1 = __importDefault(require("dexie"));
const NAME = "snort-system";
const VERSION = 2;
const STORES = {
    users: "++pubkey, name, display_name, picture, nip05, npub",
    relayMetrics: "++addr",
    userRelays: "++pubkey",
    events: "++id, pubkey, created_at"
};
class SnortSystemDb extends dexie_1.default {
    constructor() {
        super(NAME);
        this.ready = false;
        this.version(VERSION).stores(STORES);
    }
    isAvailable() {
        if ("indexedDB" in window) {
            return new Promise(resolve => {
                const req = window.indexedDB.open("dummy", 1);
                req.onsuccess = () => {
                    resolve(true);
                };
                req.onerror = () => {
                    resolve(false);
                };
            });
        }
        return Promise.resolve(false);
    }
}
exports.SnortSystemDb = SnortSystemDb;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvY2FjaGUvZGIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7O0FBRUEsa0RBQXFDO0FBRXJDLE1BQU0sSUFBSSxHQUFHLGNBQWMsQ0FBQztBQUM1QixNQUFNLE9BQU8sR0FBRyxDQUFDLENBQUM7QUFFbEIsTUFBTSxNQUFNLEdBQUc7SUFDWCxLQUFLLEVBQUUsb0RBQW9EO0lBQzNELFlBQVksRUFBRSxRQUFRO0lBQ3RCLFVBQVUsRUFBRSxVQUFVO0lBQ3RCLE1BQU0sRUFBRSwwQkFBMEI7Q0FDckMsQ0FBQztBQUVGLE1BQWEsYUFBYyxTQUFRLGVBQUs7SUFRcEM7UUFDSSxLQUFLLENBQUMsSUFBSSxDQUFDLENBQUM7UUFSaEIsVUFBSyxHQUFHLEtBQUssQ0FBQztRQVNWLElBQUksQ0FBQyxPQUFPLENBQUMsT0FBTyxDQUFDLENBQUMsTUFBTSxDQUFDLE1BQU0sQ0FBQyxDQUFDO0lBQ3pDLENBQUM7SUFFRCxXQUFXO1FBQ1AsSUFBSSxXQUFXLElBQUksTUFBTSxFQUFFO1lBQ3ZCLE9BQU8sSUFBSSxPQUFPLENBQVUsT0FBTyxDQUFDLEVBQUU7Z0JBQ2xDLE1BQU0sR0FBRyxHQUFHLE1BQU0sQ0FBQyxTQUFTLENBQUMsSUFBSSxDQUFDLE9BQU8sRUFBRSxDQUFDLENBQUMsQ0FBQztnQkFDOUMsR0FBRyxDQUFDLFNBQVMsR0FBRyxHQUFHLEVBQUU7b0JBQ2pCLE9BQU8sQ0FBQyxJQUFJLENBQUMsQ0FBQztnQkFDbEIsQ0FBQyxDQUFDO2dCQUNGLEdBQUcsQ0FBQyxPQUFPLEdBQUcsR0FBRyxFQUFFO29CQUNmLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQztnQkFDbkIsQ0FBQyxDQUFDO1lBQ04sQ0FBQyxDQUFDLENBQUM7U0FDTjtRQUNELE9BQU8sT0FBTyxDQUFDLE9BQU8sQ0FBQyxLQUFLLENBQUMsQ0FBQztJQUNsQyxDQUFDO0NBQ0o7QUEzQkQsc0NBMkJDIn0=